import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import {
  handleStatus,
  requestedList,
  searchCentralStoreProductList,
} from "../../../services/centralStore/centralStore"
import { toastSuccess } from "../../../helpers/msg_helper"
import moment from "moment"
import RequestFilter from "./filter"
import { capitalize } from "lodash"
import { searchMaterialRequestFinance } from "../../../services/procurement/materialrequest"
import { useLocation, useNavigate } from "react-router-dom"
import NumberFormat from "../../../utils/numberFormat"

const RequestedList = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Inward PMR${companyname ? ` | ${companyname}` : ''}`;

  const [page, setPage] = useState("")
  const [productList, setProductList] = useState("")
  const [count, setCount] = useState(0)
  const [status, setStatus] = useState("")
  const [statusPMR, setStatusPMR] = useState("")
  const [search, setSearch] = useState("")
  const [type, setType] = useState("")
  const [user, setUser] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange") || 2

  useEffect(() => {
    const fetchData = async () => {
      const response = await searchMaterialRequestFinance({
        params: `${statusPMR ? `&status=${statusPMR}` : `&pmr_only=true`}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${datefrom ? `&requestdate_from=${datefrom}` : ""}${dateto ? `&requestdate_to=${dateto}` : ""
          }${page ? `&page=${page}` : ""}${`&sizePerPage=16`}${user ? `&mr_no=${user}` : ""
          }${`&is_project=${true}`}${status ? `&custom_status=${status}` : ""}
        ${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })

      const updatedResponse = {
        ...response,
        data: {
          ...response.data,
          data: response.data?.data?.map(item => ({
            ...item,
            children: [
              // ...(item.dr || []).map(d => ({ ...d, type: "Delivery Note" })),
              ...(item.smr || []).map(s => ({ ...s, type: "SMR" })),
            ],
          })),
        },
      }
      // setProductList(updatedResponse)
      setProductList(prev =>
        page > 1 && prev
          ? {
            ...updatedResponse,
            data: {
              ...updatedResponse.data,
              data: [
                ...(prev.data?.data || []),
                ...(updatedResponse.data?.data || [])
              ],
            },
          }
          : updatedResponse
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, status, search, page, type, user, datefrom, dateto, statusPMR, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < productList?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [productList, page]);

  const columns = [
    {
      label: "PMR No.",
      renderCell: item => {
        return (
          <div className="d-flex">
            <div
              onClick={() =>
                navigate(`/inventory-inward-pmr/view/${item?.id}`, {
                  state: { message: "inventory", name: crumb },
                })
              }
              className="pointer fw-bold"
            >
              {item?.code}
            </div>
            <div
              className={`ms-2 ${item?.custom_status == "Fully Delivered"
                ? "status-active-cap"
                : item?.custom_status == "Delivery On Process"
                  ? "status-draft-cap"
                  : "status-inactive-cap"
                }`}
            >
              {item?.custom_status ? item?.custom_status : ""}
            </div>
          </div>
        )
      },
    },
    {
      label: "Project Code",
      renderCell: item => item?.project?.project_code,
    },
    {
      label: <div className="text-end pe-3">Req Qty.</div>,
      renderCell: item => (
        <div className="text-end pe-3">
          {NumberFormat(
            Number(item?.materials_sum_requested_quantity),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-3">Delivered Qty.</div>,
      renderCell: item => {
        const totalDeliveredQty = item?.dr?.reduce(
          (acc, curr) => acc + parseFloat(curr?.materials_sum_quantity || 0),
          0
        )

        return (
          <div className="text-end pe-3">
            {NumberFormat(totalDeliveredQty, desimalrange, desimalrange)}
          </div>
        )
      },
    },
    {
      label: "Request date",
      renderCell: item => moment(item?.request_date).format("DD-MM-YYYY"),
    },
    {
      label: "Expected Delivery Date",
      renderCell: item => moment(item?.exp_Delivery_date).format("DD-MM-YYYY"),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1
              ? "status-draft"
              : item?.status === 2
                ? "status-posted"
                : item?.status === 3
                  ? "status-active"
                  : item?.status === 4 ? "status-inactive" : "status-inactive"
              }`}
          >
            {item?.status === 1
              ? "Draft"
              : item?.status === 2
                ? "Requested"
                : item?.status === 3
                  ? "Approved"
                  : item?.status === 4
                    ? "Rejected"
                    : "Closed"}
          </span>
        </div>
      ),
    },
  ]

  const subOnGoingColumns = [
    {
      label: "Ref No.",
      renderCell: item => {
        return <div>{item?.code}</div>
      },
    },

    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(
              item?.materials_sum_quantity
                ? item?.materials_sum_quantity
                : item?.materials_sum_requested_quantity
            ),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: "Type",
      renderCell: item => item?.type,
    },
    {
      label: "",
      renderCell: item => <></>,
    },
    {
      label: "",
      renderCell: item => <div></div>,
    },
  ]

  const handleAction = async (id, status) => {
    const responce = await handleStatus(id, status)
    toastSuccess(responce?.message)
    setCount(count + 1)
  }

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleUserChange = id => {
    setUser(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  const handleStatusPMRChange = id => {
    setStatusPMR(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Inventory"
              breadcrumbObject={[
                { title: "Inventory", link: "/inventory" },
                { title: crumb || "Store Masters", link: "/inventory" },
                {
                  title: "Inward PMR",
                  link: "/inventory-inward-pmr",
                },
              ]}
            />
          </div>

          <Card className="me-2 px-2 pb-2">
            <RequestFilter
              handleTypeChange={handleTypeChange}
              handleSearchChange={handleSearchChange}
              handleUserChange={handleUserChange}
              handleDateChange={handleDateChange}
              handleStatusChange={handleStatusChange}
              handleStatusPMRChange={handleStatusPMRChange}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table pmr-tbl">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ height: "490px", overflowY: "auto" }}>
                {productList?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={productList?.data?.data}
                    paginate={productList?.data}
                    columns={columns}
                    subColumn={subOnGoingColumns}
                    subName={"children"}
                    expand={true}
                    subHeader={true}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="20% 10% 10% 10% 20% 20% 10%"
                    mobileWidth="40% 40% 30% 30% 30% 30% 30%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
export default RequestedList
